/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetPayableQueryResponse, GetPayablePathParams, GetPayable400, GetPayable401, GetPayable403, GetPayable404, GetPayable409, GetPayable500 } from "../../types/financialHubController/GetPayable.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetPayableUrl(organizationId: GetPayablePathParams["organizationId"], billId: GetPayablePathParams["billId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/payables/${billId}` as const }
  return res
}

/**
 * @summary Get a supplier bill with its installments + payments
 * {@link /api/organizations/:organizationId/financial/payables/:billId}
 */
export async function getPayable(organizationId: GetPayablePathParams["organizationId"], billId: GetPayablePathParams["billId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetPayableQueryResponse, ResponseErrorConfig<GetPayable400 | GetPayable401 | GetPayable403 | GetPayable404 | GetPayable409 | GetPayable500>, unknown>({ method : "GET", url : getGetPayableUrl(organizationId, billId).url.toString(), ... requestConfig })
  return res.data
}